import { CONSTANTS } from "../../constants";
import { dataTransferService } from "../../services/dataTransferService";
import { statusBoardService } from "./StatusBoard.service";
import { socketUrl, decodedAuthToken } from "../../services/socketUrl";

// Was hardcoded to the vendor host wss://thecallcentral.com/api/v1/, so these
// sockets never reached this deployment. Resolved from
// REACT_APP_WEB_SOCKETURL instead. Note the server routes live at the base,
// not under /api/v1/.
let socket: any;
let sbSocket: any;
let getConnection = false;
let path: any = "sboard/unit/list";
let reminderPath: any = "sboard/unit/reminder-nurse";
let uniqueID: any = "_" + Math.random().toString(36).substr(2, 9);

const getStatusBoardInputConnection = (params: any) => {
  socket = new WebSocket(
    socketUrl(
      `${path}/${params.sbId}/${params.patientId}/`,
      decodedAuthToken()
    )
  );

  socket.onopen = function open() {};

  socket.onmessage = function message(event: any) {
    let socketMessage: any;
    try {
      socketMessage = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    if (socketMessage.type_do === "refresh") {
      switch (socketMessage.type_on) {
        case "notes":
          dataTransferService.transferNotesListAction(socketMessage.type_on);
          break;
        case "reminders":
          dataTransferService.transferReminderListAction(socketMessage.type_on);
          break;
        case "providers":
          dataTransferService.transferProviderListAction(socketMessage.type_on);
          break;
        case "sms":
          dataTransferService.transferSmsListAction(socketMessage.type_on);
          break;
        case "my_patient_remove":
          dataTransferService.transferProviderListAction(socketMessage.type_on);
          break;
      }
    }
  };

  socket.onerror = function (e: any) {};

  socket.onclose = function (e: any) {
    if (getConnection === false) {
      getStatusBoardInputConnection(params);
    }
  };
};

const sendSbInputSocketParams = (params: any) => {
  socket.send(JSON.stringify(params));
};

const closeSbInputSocketConnection = () => {
  if (socket) {
    socket.close();
    getConnection = true;
  }
};

const getStatusBoardSocketConnection = (path: any, params: any) => {
  // The separator was missing here, building "sboard/unit/list7/" rather than
  // "sboard/unit/list/7/".
  sbSocket = new WebSocket(
    socketUrl(`${path}/${params.sbId}/`, decodedAuthToken())
  );
  sbSocket.onopen = function open() {};

  sbSocket.onmessage = function message(event: any) {
    let socketMessage: any;
    try {
      socketMessage = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    if (uniqueID !== socketMessage.updatedUniqueId) {
      applyChanges(socketMessage);
    }
  };

  sbSocket.onerror = function (e: any) {};

  sbSocket.onclose = function (e: any) {
    if (getConnection === false) {
      getStatusBoardSocketConnection(path, params);
    }
  };
};

const sendSbSocketParams = (params: any) => {
  sbSocket.send(JSON.stringify(params));
};

const closeSbSocketConnection = () => {
  if (sbSocket) {
    sbSocket.close();
    getConnection = true;
  }
};

const applyChanges = (socketMessage: any) => {
  switch (socketMessage.socketType) {
    case CONSTANTS.SOCKET_TYPE.CARE_TEAM_ON:
      statusBoardService.notifyBed(socketMessage.bedId);
      break;
    case CONSTANTS.SOCKET_TYPE.CARE_TEAM_OFF:
      statusBoardService.removeIndicationForBed(socketMessage.bedId);
      break;
    case CONSTANTS.SOCKET_TYPE.DISCHARGE:
    case CONSTANTS.SOCKET_TYPE.SWAP_TRANSFER:
      statusBoardService.updateTable(socketMessage);
      break;
    case CONSTANTS.SOCKET_TYPE.CUSTOM_COLUMNS:
    case CONSTANTS.SOCKET_TYPE.DATATABLE_ROW:
    case CONSTANTS.SOCKET_TYPE.ADD_EDIT_PATIENT:
    case CONSTANTS.SOCKET_TYPE.PRIMARY_MD:
      statusBoardService.updateTable(socketMessage);
      break;
    case CONSTANTS.SOCKET_TYPE.NURSE_UPDATE:
      statusBoardService.updateTable(socketMessage);
      break;
    case CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_LIST:
    case CONSTANTS.SOCKET_TYPE.CARE_TEAM_LIST:
    case CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_UPDATE:
      statusBoardService.updateCareTeamSupportStaff(socketMessage);
      break;
    case CONSTANTS.SOCKET_TYPE.NURSE_SMS:
      //   setMessageListData
      break;
  }
};

export const statusBoardSocketService = {
  getStatusBoardSocketConnection,
  sendSbSocketParams,
  applyChanges,
  closeSbSocketConnection,
  getStatusBoardInputConnection,
  sendSbInputSocketParams,
  closeSbInputSocketConnection,
  uniqueID,
};
